const trail = [];

export function addTrail(performedAction) {
  trail.push(performedAction);
  console.log({ trail });
}

export function getTrail() {
  return trail;
}
